import React from 'react'
import { Container, Navbar, Row, Col } from 'react-bootstrap';

const Header = () => {
    return (
        <Container fluid>
            <Row className="my-3">
                <Col >
                    <Navbar.Brand href="/">
                        <img src="/Logo_Smash_API_Violet.png" alt="" height="24" />
                    </Navbar.Brand>
                </Col>
            </Row>
        </Container>
    )
}

export default Header